import type { HouseHold } from '@appTypes/customerInformationType';
import { ProductID } from './ProductID';

export enum SubscriptionChangeOperation {
  NoAction = 0,
  CanBeCancelled = 1,
  CanBeUnCancelled = 2,
}

export const hasCancellableSubscriptionChange = (household?: HouseHold): boolean =>
  !!household?.householdChanges?.subscriptionsChanges?.some(
    (change) => change.changeOperation === SubscriptionChangeOperation.CanBeCancelled,
  );

export const householdHasRoadsideDowngrade = (household?: HouseHold): boolean =>
  !!household?.householdChanges?.globalChanges?.downgradeProducts?.some(
    (product) => product.id === ProductID.RoadSideAssistance && product.subscriptionLines?.length > 0,
  );

export const householdMemberHasCancellableChange = (household: HouseHold | undefined, customerId: string): boolean =>
  !!household?.householdChanges?.subscriptionsChanges?.some(
    (change) =>
      change.customerId === customerId && change.changeOperation === SubscriptionChangeOperation.CanBeCancelled,
  );

export const householdMemberHasMcDowngrade = (household: HouseHold | undefined, customerId: string): boolean => {
  const change = household?.householdChanges?.subscriptionsChanges?.find((entry) => entry.customerId === customerId);
  return !!change?.downgradeProducts?.some((product) => product.id === ProductID.MC);
};
